import React from 'react';
import { useTranslation } from 'react-i18next';
import { ICampaignOverview } from '../../../../../model/briefing/overview/ICampaignOverview';
import { ContractMobileCard } from './ContractMobileCard';
import { Col, Row } from 'react-bootstrap';
import { UserRoles } from '../../../../../enum/UserRoles';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { useNavigate } from 'react-router-dom';
import ContractListItem from './ContractListItem';

interface IContractListProps {
    campaigns?: ICampaignOverview[];
}

export function ContractList({ campaigns }: IContractListProps) {
    const { t } = useTranslation();
    const {
        user: { userType },
    } = useSelector((state: IAllStates) => state.auth);
    const navigate = useNavigate();

    const navigateToMyCampaigns = () => {
        [UserRoles.AGENCY, UserRoles.AGENCY_MASTER].includes(userType as UserRoles)
            ? navigate('/agency/campaigns')
            : navigate('/influencer/campaigns');
    };

    return (
        <div className="my-2">
            <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-lg-4 mb-0">{t('influencer.dashboard.long_term_contracts')}</h4>

                <p onClick={navigateToMyCampaigns} className="d-lg-none text-uppercase text-muted text-underline mb-0">
                    {t('influencer.header.myCampaigns')}
                </p>
            </div>
            <Row>
                {campaigns?.map(campaign => (
                    <Col key={campaign?.id} className="my-2 col-12 mb-3">
                        <div className="d-lg-none">
                            <ContractMobileCard campaign={campaign} />
                        </div>
                        <div className="d-none d-lg-block">
                            <ContractListItem campaign={campaign} />
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
}
